import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 40px;
  box-sizing: border-box;
  background-image: url("/textura.jpg");
  background-size: cover;
  background-attachment: fixed;
  animation: ${fadeIn} 0.5s ease-out;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const ContentBox = styled.div`
  background: rgba(20, 20, 20, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 30px;
  border: 1px solid rgba(230, 170, 58, 0.1);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);

  h2 {
    margin: 0;
    color: #e6aa3a;
    font-size: 24px;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 12px;
    letter-spacing: 0.5px;
  }
`;

/* --- TAB STYLES --- */
export const TabContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export const TabButton = styled.button`
  background: transparent;
  color: ${(props) => (props.active ? "#E6AA3A" : "rgba(255, 255, 255, 0.5)")};
  border: none;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  padding: 12px 5px;
  position: relative;
  transition: all 0.3s ease;
  outline: none;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &:after {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 3px;
    background: #e6aa3a;
    transform: scaleX(${(props) => (props.active ? 1 : 0)});
    transform-origin: left;
    transition: transform 0.3s ease;
    box-shadow: 0 -2px 10px rgba(230, 170, 58, 0.5);
  }

  &:hover {
    color: #e6aa3a;
  }
`;

/* --- FILTERS AREA --- */
export const SearchArea = styled.div`
  background: rgba(255, 255, 255, 0.02);
  padding: 20px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  margin-bottom: 30px;

  display: grid;
  /* Cria colunas automáticas com largura mínima, e o botão ocupa o espaço restante ou nova linha */
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  align-items: end;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    font-size: 11px;
    color: #9ca3af;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 0.5px;
  }

  .input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
  }

  input,
  select {
    width: 100%;
    height: 48px; /* Altura fixa para alinhar */
    background: #111;
    border: 1px solid #333;
    border-radius: 6px;
    padding: 0 15px;
    color: #fff;
    font-size: 14px;
    outline: none;
    transition: all 0.2s;
    box-sizing: border-box;

    &:focus {
      border-color: #e6aa3a;
      box-shadow: 0 0 0 2px rgba(230, 170, 58, 0.1);
    }

    &::placeholder {
      color: #555;
    }
  }

  /* Estilo específico para o input de busca com botão dentro */
  .search-input {
    padding-right: 50px; /* Espaço para o ícone */
  }

  .search-icon-btn {
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    color: #e6aa3a;
    font-size: 18px;
    cursor: pointer;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: #fff;
    }
  }
`;

/* Botão Principal de Filtrar */
export const FilterButton = styled.button`
  height: 48px;
  background: #333;
  color: #fff;
  border: 1px solid #555;
  font-weight: 600;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  text-transform: uppercase;
  letter-spacing: 1px;
  width: 100%;

  &:hover {
    background: #444;
    border-color: #777;
  }
`;

/* Botão de NOVA CAIXINHA (Destaque) */
export const NewBoxButton = styled.button`
  height: 48px;
  background: linear-gradient(135deg, #e6aa3a, #b88a2d);
  color: #000;
  font-weight: 800;
  font-size: 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 4px 15px rgba(230, 170, 58, 0.2);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(230, 170, 58, 0.3);
    filter: brightness(1.1);
  }

  &:active {
    transform: translateY(0);
  }
`;

/* --- TABLE STYLES --- */
export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  background: rgba(0, 0, 0, 0.2);
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;
`;

export const TableHead = styled.thead`
  background: rgba(255, 255, 255, 0.03);

  th {
    padding: 18px 20px;
    text-align: left;
    color: #888;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
`;

export const TableBody = styled.tbody`
  tr {
    border-bottom: 1px solid rgba(255, 255, 255, 0.03);
    transition: background 0.2s;
    cursor: pointer;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: rgba(230, 170, 58, 0.05);
    }

    td {
      padding: 16px 20px;
      color: #e5e5e5;
      font-size: 14px;
      vertical-align: middle;
      font-weight: 500;
    }
  }
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: center;
  min-width: 80px;

  ${(props) => {
    switch (props.status) {
      case 0: // PENDING
        return `background: rgba(245, 158, 11, 0.15); color: #fbbf24; border: 1px solid rgba(245, 158, 11, 0.3);`;
      case 1: // ACTIVE / PAID
        return `background: rgba(16, 185, 129, 0.15); color: #34d399; border: 1px solid rgba(16, 185, 129, 0.3);`;
      case 2: // REJECTED
        return `background: rgba(239, 68, 68, 0.15); color: #f87171; border: 1px solid rgba(239, 68, 68, 0.3);`;
      case 3: // FINISHED
        return `background: rgba(59, 130, 246, 0.15); color: #60a5fa; border: 1px solid rgba(59, 130, 246, 0.3);`;
      case 4: // CANCELED
        return `background: rgba(107, 114, 128, 0.15); color: #9ca3af; border: 1px solid rgba(107, 114, 128, 0.3);`;
      default:
        return `background: rgba(255, 255, 255, 0.1); color: #fff;`;
    }
  }}
`;

export const ActionButton = styled.button`
  border: none;
  border-radius: 4px;
  padding: 6px 14px;
  font-size: 11px;
  font-weight: 800;
  cursor: pointer;
  margin-right: 8px;
  color: white;
  transition: all 0.2s;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &:hover {
    filter: brightness(1.1);
    transform: translateY(-1px);
  }

  &.approve {
    background: #10b981; /* Verde */
    box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
  }
  &.reject {
    background: #ef4444; /* Vermelho */
    box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 25px;
  gap: 12px;

  span {
    color: #888;
    font-size: 14px;
  }

  button {
    background: #111;
    color: #fff;
    border: 1px solid #333;
    border-radius: 6px;
    padding: 8px 16px;
    font-weight: 600;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover:not(:disabled) {
      border-color: #e6aa3a;
      color: #e6aa3a;
    }

    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }
`;

export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
`;

export const MetricCard = styled.div`
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(230, 170, 58, 0.2);
  border-radius: 10px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    border-color: rgba(230, 170, 58, 0.5);
    background: rgba(255, 255, 255, 0.05);
  }

  .icon-box {
    width: 50px;
    height: 50px;
    border-radius: 12px;
    background: rgba(230, 170, 58, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #e6aa3a;
  }

  .info {
    display: flex;
    flex-direction: column;

    span.label {
      font-size: 12px;
      color: #9ca3af;
      text-transform: uppercase;
      font-weight: 700;
      letter-spacing: 0.5px;
      margin-bottom: 4px;
    }

    span.value {
      font-size: 20px;
      color: #fff;
      font-weight: 800;
      letter-spacing: 0.5px;
    }
  }
`;

export const InfoTooltip = styled.span`
  margin-left: 8px;
  color: #e6aa3a;
  font-size: 14px;
  cursor: help;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  /* O Balão de Texto */
  &:after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: 130%; /* Fica acima do icone */
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.95);
    border: 1px solid rgba(230, 170, 58, 0.3);
    color: #fff;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 400;
    white-space: pre-wrap; /* Permite quebrar linha se for muito longo */
    width: max-content;
    max-width: 220px;
    text-align: center;
    text-transform: none;
    z-index: 100;
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease-in-out;
    box-shadow: 0 4px 15px rgba(0,0,0,0.5);
    pointer-events: none;
  }

  /* A setinha do balão */
  &:before {
    content: '';
    position: absolute;
    bottom: 120%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: rgba(230, 170, 58, 0.3);
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease-in-out;
    z-index: 100;
  }

  &:hover:after,
  &:hover:before {
    opacity: 1;
    visibility: visible;
    bottom: 140%; /* Pequena animação subindo */
  }
  
  &:hover:before {
    bottom: 130%; /* Ajuste da seta */
  }
`;